let scrollRegionsErrorCount = 0;
let isReloading = false;
const MAX_RELOAD_ATTEMPTS = 3;

const handleScrollRegionsError = (errorType) => {
    scrollRegionsErrorCount++;

    if (scrollRegionsErrorCount > MAX_RELOAD_ATTEMPTS || isReloading) {
        console.error("Too many scrollRegions errors or already reloading");
        return false;
    }

    console.warn(
        `Caught scrollRegions ${errorType}, reloading page (${scrollRegionsErrorCount}/${MAX_RELOAD_ATTEMPTS})`
    );

    isReloading = true;
    setTimeout(() => window.location.reload(), 100);

    return true;
};

export const resetScrollRegionsErrorCount = () => {
    scrollRegionsErrorCount = 0;
};

export const initInertiaErrorHandler = () => {
    window.addEventListener("error", (event) => {
        if (event.message?.includes("scrollRegions")) {
            event.preventDefault();
            handleScrollRegionsError("error");
            return false;
        }
    });

    window.addEventListener("unhandledrejection", (event) => {
        if (event.reason?.message?.includes("scrollRegions")) {
            event.preventDefault();
            handleScrollRegionsError("promise rejection");
        }
    });
};
